// extracted by mini-css-extract-plugin
export default {"center":"DocLayout_center__Rs5LG","content":"DocLayout_content__xuRrM","children":"DocLayout_children__2Rhf7"};